import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    tvChannels: [],
    tvChannelsMetadata: {},
    tvChannel: {}
  }
})
  .get({
    action: 'getTvChannels',
    property: 'tvChannels',
    queryParams: true,
    path: '/tv-channels/',
    onSuccess: payloadToState('tvChannels')
  })
  .post({
    action: 'createTvChannel',
    property: 'tvChannel',
    path: '/tv-channels/',
    onSuccess: payloadToState('tvChannel')
  })
  .get({
    action: 'getTvChannel',
    property: 'tvChannel',
    path: ({ id }) => `/tv-channels/${id}`,
    onSuccess: payloadToState('tvChannel')
  })
  .put({
    action: 'updateTvChannel',
    property: 'tvChannel',
    path: ({ id }) => `/tv-channels/${id}`,
    onSuccess: payloadToState('tvChannel')
  })
  .getStore()
